import { HandleType } from '@kanda-libs/ks-component-ts';

export const AGREED_TERMS_PROPS = {
  handle: 'checkbox' as HandleType,
  name: 'terms.agreed_terms',
};

export const TERMS_COPY = {
  part1: 'I confirm I have taken the time to read ',
  link: "Ideal4Finance's Terms and Conditions",
  part2: ' and agree to them',
};

export const TERMS_URL = 'https://www.getkanda.com/legal-page#customer-terms';
